export const getCookie = (key) => {
    const encodedName = encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&');
    const regex = new RegExp('(?:(?:^|.*;)\\s*' + encodedName + '\\s*\\=\\s*([^;]*).*$)|^.*$');
    return decodeURIComponent(document.cookie.replace(regex, '$1')) || null;
};
export const setCookie = (key, value, days) => {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = key + '=' + value + expires + '; path=/';
};
export const removeCookie = (key) => {
    setCookie(key, '', -1);
};
//# sourceMappingURL=storage.js.map